import { makeStyles } from '@material-ui/core';
export default makeStyles((theme) => ({
  headerBox: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end',
    paddingBottom: 20,
    '@media (max-width: 1024px)': {
      flexDirection: 'row-reverse',
      paddingLeft: 30,
    },
  },
  userNameHeaderText: {
    fontSize: 16,
    color: theme.palette.common.black,
    margin: 0,
    alignSelf: 'center',
    paddingRight: 10,
    letterSpacing: 0.3,
    '@media (max-width: 1024px)': {
      paddingLeft: 12,
    },
  },
  avatarImg: {
    background: theme.palette.primary.contrastText,
    height: 22,
    width: 22,
    borderRadius: '50%',
    boxShadow: theme.shadows[5],
    padding: 7,
  },
  menuIcon: {
    height: 17.5,
    marginRight: 10,
  },
  avatarMenu: {
    '& .MuiMenu-paper': {
      marginTop: 50,
      borderRadius: 11,
      boxShadow: theme.shadows[3],
      minWidth: 180,
    },
    '& .MuiMenuItem-root': {
      fontSize: 16,
      fontFamily: theme.typography.fontFamily,
      padding: '10px 23px',
      color: theme.palette.warning.contrastText,
    },
  },
}));
